import { IconSprite } from "../../../../ui/IconSprite/IconSprite";

import { Rotate } from "../../../../ui/Rotate/Rotate.styled";
import { Button, Title } from "./HeaderNavButton.styled";

export const HeaderNavButton = ({ children, handler, isDropDownOpen }) => {
  return (
    <Button
      component="button"
      type="button"
      className="label"
      onTouchStart={handler}
      onKeyDown={event => {
        if (event.key === "Enter") {
          handler();
        }
      }}
    >
      <Title>{children}</Title>
      <Rotate isOpen={isDropDownOpen}>
        <IconSprite tag="arrowDropdown" width="18" height="19" />
      </Rotate>
    </Button>
  );
};
